import { render, staticRenderFns } from "./CCButtonBadge.vue?vue&type=template&id=0fb8d38c&scoped=true&"
import script from "./CCButtonBadge.vue?vue&type=script&lang=js&"
export * from "./CCButtonBadge.vue?vue&type=script&lang=js&"
import style0 from "./CCButtonBadge.vue?vue&type=style&index=0&id=0fb8d38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8d38c",
  null
  
)

export default component.exports